/**
 * GraphQL operations that are allowed to run without authentication
 * and should be considered for cache persistence
 */
export const ALLOWED_OPERATIONS = [
  'processingPartners',
  'processingPartnersOne',
  'CalculateProcessorCapacity',
  'processorSchedulingMany',
  'processorSchedulingOne',
  'ProcessorSchedulingById',
  'ViewProcessingPartner',
  'CreateProcessorScheduling',
  'ViewSchedulingCreate',
  'CutsheetCreateOne',
  'WaitlistAdd',
  'WaitlistUnsubscribe',
  'MyChatRooms',
  'MessagesByChatRoom',
  'SendMessage',
  'LandingPageOne',
  'LandingPagePublicById',
  'LandingPagePublicBySlug',
  // Public buyer-browse surface — keep in sync with excludedOperationNames in
  // packages/api/src/auth.ts. Anonymous visitors browse /buyer/available,
  // /buyer/processor/:slug, /processors/:slug (T7.2 canonical route), and
  // /buyer/animal/:animalId without a token.
  'BuyerAvailableAnimals',
  'BuyerAnimalDetail',
  'GeocodeLocation',
  // Public producer page header (Phase 1b). Keep in sync with
  // excludedOperationNames in packages/api/src/auth.ts.
  'ProducerBySlug',
  // Public producer available-splits query (Phase 3). Keep in sync with
  // excludedOperationNames in packages/api/src/auth.ts.
  'ProducerAvailableSplits',
  // Public producer offered-species query — drives the follow-a-farm notify
  // toggles on the public producer page (Follow-a-Producer Phase 1). Keep in
  // sync with excludedOperationNames in packages/api/src/auth.ts.
  'ProducerOfferedSpecies',
  // Tokenized, no-login marketplace-interest unsubscribe (Notifications
  // Phase 9) — mirrors WaitlistUnsubscribe above. Keep in sync with
  // excludedOperationNames in packages/api/src/auth.ts.
  'BuyerInterestUnsubscribe',
  // Confirmable notifications: the no-login page an email's confirm / decline
  // links open. Keep in sync with excludedOperationNames in
  // packages/api/src/auth.ts.
  'NotificationPromptByToken',
  'NotificationPromptAnswerByToken',
  // Public marketplace lead capture (empty-state intake form). Keep in sync
  // with excludedOperationNames in packages/api/src/auth.ts.
  'MarketplaceLeadSubmit',
  // Wild-game kiosk (PRO-697) — a tablet in a plant's lobby, no login by
  // design, so the URL's token is the whole credential. Keep in sync with
  // excludedOperationNames in packages/api/src/auth.ts.
  'GameKioskByToken',
  'GameKioskCutsheet',
  'GameKioskDropoffCreate',
  'GameKioskHunterCheck',
] as const;

/**
 * Operations that should be persisted to localStorage
 * This is a subset of ALLOWED_OPERATIONS focusing on cacheable queries
 * (excluding mutations and real-time data like chat messages)
 */
export const PERSISTENT_OPERATIONS = [
  'cancellationReasonMany',
  'UserTenantVendor',
  'userTenantVendor',
  'UserSettingsByUserId',
] as const;
